"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Zip = exports.Street = exports.State = exports.Name = exports.City = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
const joinLocationFields = location => (0, _filter.default)(location).call(location, v => !!v).join(', ');
const Street = _ref => {
  let {
    street1,
    street2,
    suite
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    itemProp: "streetAddress"
  }, joinLocationFields([street1, street2, suite]));
};
exports.Street = Street;
const City = props => /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
  itemProp: "addressLocality"
}));
exports.City = City;
const State = props => /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
  itemProp: "addressRegion"
}));
exports.State = State;
const Zip = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("span", {
    itemProp: "postalCode"
  }, children);
};
exports.Zip = Zip;
const Name = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("h5", null, children);
};
exports.Name = Name;
Street.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Street"
};
City.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "City"
};
State.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "State"
};
Zip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Zip"
};
Name.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Name"
};